import { MENU_ITEMS } from '../../data/menu';
import type { MenuItemId } from '../types';

export interface PrepTicket {
  id: number;
  customerId: number;
  item: MenuItemId;
  remaining: number;
  ready: boolean;
}

export class PreparationSystem {
  readonly tickets: PrepTicket[] = [];
  private nextId = 1;

  constructor(private readonly coffeePrepMultiplier = 1) {}

  submit(customerId: number, item: MenuItemId): PrepTicket {
    const ticket: PrepTicket = {
      id: this.nextId++,
      customerId,
      item,
      remaining: MENU_ITEMS[item].prepSeconds * (MENU_ITEMS[item].preparationKind === 'HOT_DRINK' ? this.coffeePrepMultiplier : 1),
      ready: false,
    };
    this.tickets.push(ticket);
    return ticket;
  }

  submitOrder(customerId: number, items: MenuItemId[]): PrepTicket[] {
    return items.map((item) => this.submit(customerId, item));
  }

  update(deltaSeconds: number): PrepTicket[] {
    const newlyReady: PrepTicket[] = [];
    this.tickets.forEach((ticket) => {
      if (ticket.ready) return;
      ticket.remaining -= deltaSeconds;
      if (ticket.remaining <= 0) {
        ticket.remaining = 0;
        ticket.ready = true;
        newlyReady.push(ticket);
      }
    });
    return newlyReady;
  }

  takeFirstReady(preferredCustomerId?: number): PrepTicket | undefined {
    const preferredIndex = preferredCustomerId === undefined ? -1 : this.tickets.findIndex((ticket) => ticket.ready && ticket.customerId === preferredCustomerId);
    const index = preferredIndex >= 0 ? preferredIndex : this.tickets.findIndex((ticket) => ticket.ready);
    if (index < 0) return undefined;
    return this.tickets.splice(index, 1)[0];
  }

  readyCountForCustomer(customerId: number): number {
    return this.tickets.filter((ticket) => ticket.customerId === customerId && ticket.ready).length;
  }

  forceReady(): void {
    this.tickets.forEach((ticket) => {
      ticket.remaining = 0;
      ticket.ready = true;
    });
  }

  accelerateFirstPending(seconds: number): PrepTicket | undefined {
    const ticket = this.tickets.find((candidate) => !candidate.ready);
    if (!ticket) return undefined;
    ticket.remaining = Math.max(0.15, ticket.remaining - seconds);
    return ticket;
  }

  cancelCustomer(customerId: number): void {
    for (let index = this.tickets.length - 1; index >= 0; index -= 1) {
      if (this.tickets[index].customerId === customerId) this.tickets.splice(index, 1);
    }
  }

  clear(): void {
    this.tickets.length = 0;
  }
}
